import axios from "axios";
import { assignSupportTicketType, updateComplaintType, uploadReportType } from "../features/support/SupportTypes";
import { getAccessToken, getLob } from "./authenticationService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";
import { EnvironmentRegistry } from "./registry/environmentRegistry";

export async function getReports(startDate: string, endDate: string, newSupport: boolean) {
  const loginId = JSON.parse(localStorage.authContext).user.loginId;
  const baseUrl = newSupport
    ? `/getSupportData?fromDate=${startDate}&toDate=${endDate}&loggedInUserName=${loginId}`
    : `/v1/query/getSupportData?fromDate=${startDate}&toDate=${endDate}&loggedInUserName=${loginId}`;

  const response = await ChannelkartNetworkGet(baseUrl);
  return response;
}

export async function getReportsSearchData(searchedValue:string){
  try {
    const response = await ChannelkartNetworkGet(
      `/v1/query/getSupportSearchData?searchedValue=${searchedValue}&loggedInUserName=${
        JSON.parse(localStorage.authContext).user.loginId}`
    )
    return response;
  } catch (error) {
    return error;
  }
}
export async function getReportsSearchDataNew(searchedValue:string){
  try {
    const response = await ChannelkartNetworkGet(`/support?filter=immediateId%5Bmatch%5D%3A${searchedValue}%20OR%20status%5Bmatch%5D%3A${searchedValue}%20OR%20supportClass%5Bmatch%5D%3A${searchedValue}%20OR%20loginId%3A${searchedValue}%20OR%20supportId%5Bmatch%5D%3A${searchedValue}%20OR%20supportCriteria%5Bmatch%5D%3A${searchedValue}%20OR%20blobKey%5Bmatch%5D%3A${searchedValue}%20OR%20remarks%5Bmatch%5D%3A${searchedValue}%27`)
    return response;
  } catch (error) {
    return error;
  }
}
  
  export async function getSupportUsers(role: string) {
    try {
      const response = await ChannelkartNetworkGet(
        `/users?size=100&filter=designation:${role}&source=portal&callType=scheduled`
      );
      return response;
    } catch (error) {
      return error;
    }
  }
  
  export async function assignSupportTicket(dataObj: assignSupportTicketType) {
    try {
      const response = await ChannelkartNetworkPost("/supportTracking", dataObj);
      return response;
    } catch (error) {
      return error;
    }
  }
  export async function assignSupportTicketNew(dataObj: any) {
    try {
      const response = await ChannelkartNetworkPost("/support", dataObj);
      return response;
    } catch (error) {
      return error;
    }
  }
  
  export async function updateComplaint(dataObj: updateComplaintType, token: string) {
    try {
      const response = await ChannelkartNetworkPut(`/support/${token}`, dataObj);
      return response;
    } catch (error) {
      return error;
    }
  }
  
  export async function uploadReport(dataObj: uploadReportType) {
    try {
      const response = await ChannelkartNetworkPost(
        "/tasks/types/report/execute",
        dataObj
      );
      return response;
    } catch (error) {
      return error;
    }
  }
  
  export async function getReportStatus(id: string) {
    try {
      const response = await ChannelkartNetworkGet(`/tasks/${id}`);
      return response;
    } catch (error) {
      return error;
    }
  }
  
  export async function downloadSupportReport(id: string) {
    
    console.log("downloadSupportReport")
    const serverUrl = EnvironmentRegistry.getServerUrl();
    const lob =  getLob();
    const response = await axios({
      method: "get",
      url: serverUrl + `/v1/reports/${id}`,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
        lob: lob ?? ""
      },
    });
    return response;
  }
  